// src/providers/ToastProvider.jsx
import { useState, useEffect } from "react";
import Toast from "../components/common/Toast";
import { registerToast } from "../services/toastService";

const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = (message, type) => {
    setToast({ message, type });
  };

  useEffect(() => {
    registerToast(showToast);
  }, []);

  return (
    <>
      {children}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default ToastProvider;